// extracted by mini-css-extract-plugin
export default {"heading":"AdminGroupEditPage_heading__c7lT1","relationSection":"AdminGroupEditPage_relationSection__7wrAg"};